export default __webpack_public_path__ + "static/Construction Service Provider Growth Framework-af198aaf779945ed9b5fb69e7fd0248e.wav";